import {
  createInfluencerRequestPassword,
  getOrCreateIdVerificationToken,
  getQuestionnaire,
  updateBasicInfo,
  updateTelegramInfo,
  getAlbumMediaTags,
  uploadBundle,
  saveGallery,
  saveQuestionnaireAnswers,
  uploadAudio,
  testVoice,
  saveVoice,
  updateOnboardingType,
  updateSubscriptionPrice,
  fetchInfluencerRequestAlbumMedia,
  deleteInfluencerRequestAlbumMedia,
  uploadHighQualityAudio,
  setMediaPricing,
  uploadAudioElevenLabs,
  testVoiceElevenLabs,
  saveVoiceElevenLabs,
  saveWritingStyleAnswers,
} from './asyncThunks';

export const createInfluencerRequestPasswordBuilder = builder => {
  builder.addCase(createInfluencerRequestPassword.pending, state => {
    state.pending.createInfluencerRequestPassword = true;
  });
  builder.addCase(createInfluencerRequestPassword.fulfilled, state => {
    state.pending.createInfluencerRequestPassword = false;
  });
  builder.addCase(createInfluencerRequestPassword.rejected, state => {
    state.pending.createInfluencerRequestPassword = false;
  });
};

export const updateBasicInfoBuilder = builder => {
  builder.addCase(updateBasicInfo.pending, state => {
    state.pending.updateBasicInfo = true;
  });
  builder.addCase(updateBasicInfo.fulfilled, state => {
    state.pending.updateBasicInfo = false;
  });
  builder.addCase(updateBasicInfo.rejected, state => {
    state.pending.updateBasicInfo = false;
  });
};

export const saveGalleryBuilder = builder => {
  builder.addCase(saveGallery.pending, state => {
    state.pending.saveGallery = true;
  });
  builder.addCase(saveGallery.fulfilled, state => {
    state.pending.saveGallery = false;
  });
  builder.addCase(saveGallery.rejected, state => {
    state.pending.saveGallery = false;
  });
};

export const saveQuestionnaireAnswersBuilder = builder => {
  builder.addCase(saveQuestionnaireAnswers.pending, state => {
    state.pending.saveQuestionnaireAnswers = true;
  });
  builder.addCase(saveQuestionnaireAnswers.fulfilled, state => {
    state.pending.saveQuestionnaireAnswers = false;
  });
  builder.addCase(saveQuestionnaireAnswers.rejected, state => {
    state.pending.saveQuestionnaireAnswers = false;
  });
};

export const saveWritingStyleAnswersBuilder = builder => {
  builder.addCase(saveWritingStyleAnswers.pending, state => {
    state.pending.saveWritingStyleAnswers = true;
  });
  builder.addCase(saveWritingStyleAnswers.fulfilled, state => {
    state.pending.saveWritingStyleAnswers = false;
  });
  builder.addCase(saveWritingStyleAnswers.rejected, state => {
    state.pending.saveWritingStyleAnswers = false;
  });
};

export const getOrCreateIdVerificationTokenBuilder = builder => {
  builder.addCase(getOrCreateIdVerificationToken.pending, state => {
    state.pending.getOrCreateIdVerificationToken = true;
  });
  builder.addCase(getOrCreateIdVerificationToken.fulfilled, state => {
    state.pending.getOrCreateIdVerificationToken = false;
  });
  builder.addCase(getOrCreateIdVerificationToken.rejected, state => {
    state.pending.getOrCreateIdVerificationToken = false;
  });
};

export const getQuestionnaireBuilder = builder => {
  builder.addCase(getQuestionnaire.fulfilled, (state, { payload }) => {
    state.questionnaire = payload.questionnaire;
  });
};

export const getAlbumMediaTagsBuilder = builder => {
  builder.addCase(getAlbumMediaTags.fulfilled, (state, { payload }) => {
    state.albumMediaTags = payload.albumMediaTags;
  });
};

export const updateTelegramInfoBuilder = builder => {
  builder.addCase(updateTelegramInfo.pending, state => {
    state.pending.updateTelegramInfo = true;
  });
  builder.addCase(updateTelegramInfo.fulfilled, state => {
    state.pending.updateTelegramInfo = false;
  });
  builder.addCase(updateTelegramInfo.rejected, state => {
    state.pending.updateTelegramInfo = false;
  });
};

export const uploadBundleBuilder = builder => {
  builder.addCase(uploadBundle.pending, state => {
    state.pending.uploadBundle = true;
  });
  builder.addCase(uploadBundle.fulfilled, state => {
    state.pending.uploadBundle = false;
  });
  builder.addCase(uploadBundle.rejected, state => {
    state.pending.uploadBundle = false;
  });
};

export const uploadAudioBuilder = builder => {
  builder.addCase(uploadAudio.pending, state => {
    state.pending.uploadAudio = true;
  });
  builder.addCase(uploadAudio.fulfilled, state => {
    state.pending.uploadAudio = false;
  });
  builder.addCase(uploadAudio.rejected, state => {
    state.pending.uploadAudio = false;
  });
};

export const uploadAudioElevenLabsBuilder = builder => {
  builder.addCase(uploadAudioElevenLabs.pending, state => {
    state.pending.uploadAudio = true;
  });
  builder.addCase(uploadAudioElevenLabs.fulfilled, state => {
    state.pending.uploadAudio = false;
  });
  builder.addCase(uploadAudioElevenLabs.rejected, state => {
    state.pending.uploadAudio = false;
  });
};

export const testVoiceElevenLabsBuilder = builder => {
  builder.addCase(testVoiceElevenLabs.pending, state => {
    state.pending.testVoice = true;
  });
  builder.addCase(testVoiceElevenLabs.fulfilled, state => {
    state.pending.testVoice = false;
  });
  builder.addCase(testVoiceElevenLabs.rejected, state => {
    state.pending.testVoice = false;
  });
};

export const saveVoiceElevenLabsBuilder = builder => {
  builder.addCase(saveVoiceElevenLabs.pending, state => {
    state.pending.saveVoice = true;
  });
  builder.addCase(saveVoiceElevenLabs.fulfilled, state => {
    state.pending.saveVoice = false;
  });
  builder.addCase(saveVoiceElevenLabs.rejected, state => {
    state.pending.saveVoice = false;
  });
};

export const uploadHighQualityAudioBuilder = builder => {
  builder.addCase(uploadHighQualityAudio.pending, state => {
    state.pending.uploadHighQualityAudio = true;
  });
  builder.addCase(uploadHighQualityAudio.fulfilled, state => {
    state.pending.uploadHighQualityAudio = false;
  });
  builder.addCase(uploadHighQualityAudio.rejected, state => {
    state.pending.uploadHighQualityAudio = false;
  });
};

export const testVoiceBuilder = builder => {
  builder.addCase(testVoice.pending, state => {
    state.pending.testVoice = true;
  });
  builder.addCase(testVoice.fulfilled, state => {
    state.pending.testVoice = false;
  });
  builder.addCase(testVoice.rejected, state => {
    state.pending.testVoice = false;
  });
};

export const saveVoiceBuilder = builder => {
  builder.addCase(saveVoice.pending, state => {
    state.pending.saveVoice = true;
  });
  builder.addCase(saveVoice.fulfilled, state => {
    state.pending.saveVoice = false;
  });
  builder.addCase(saveVoice.rejected, state => {
    state.pending.saveVoice = false;
  });
};

export const updateOnboardingTypeBuilder = builder => {
  builder.addCase(updateOnboardingType.pending, state => {
    state.pending.updateOnboardingType = true;
  });
  builder.addCase(updateOnboardingType.fulfilled, state => {
    state.pending.updateOnboardingType = false;
  });
  builder.addCase(updateOnboardingType.rejected, state => {
    state.pending.updateOnboardingType = false;
  });
};

export const updateSubscriptionPriceBuilder = builder => {
  builder.addCase(updateSubscriptionPrice.pending, state => {
    state.pending.updateSubscriptionPrice = true;
  });
  builder.addCase(updateSubscriptionPrice.fulfilled, state => {
    state.pending.updateSubscriptionPrice = false;
  });
  builder.addCase(updateSubscriptionPrice.rejected, state => {
    state.pending.updateSubscriptionPrice = false;
  });
};

export const fetchInfluencerRequestAlbumMediaBuilder = builder => {
  builder.addCase(fetchInfluencerRequestAlbumMedia.pending, state => {
    state.fetchInfluencerRequestAlbumMediaInfo.pending = true;
  });
  builder.addCase(fetchInfluencerRequestAlbumMedia.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.fetchInfluencerRequestAlbumMediaInfo.pending = false;
    state.fetchInfluencerRequestAlbumMediaInfo.data = data;
  });
  builder.addCase(fetchInfluencerRequestAlbumMedia.rejected, state => {
    state.fetchInfluencerRequestAlbumMediaInfo.pending = false;
  });
};

export const deleteInfluencerRequestAlbumMediaBuilder = builder => {
  builder.addCase(deleteInfluencerRequestAlbumMedia.pending, state => {
    state.pending.deleteInfluencerRequestAlbumMedia = true;
  });
  builder.addCase(deleteInfluencerRequestAlbumMedia.fulfilled, (state, { payload }) => {
    const { albumMediaId } = payload;
    state.fetchInfluencerRequestAlbumMediaInfo.data = state.fetchInfluencerRequestAlbumMediaInfo.data.filter(
      d => d.id !== albumMediaId,
    );
    state.pending.deleteInfluencerRequestAlbumMedia = false;
  });
  builder.addCase(deleteInfluencerRequestAlbumMedia.rejected, state => {
    state.pending.deleteInfluencerRequestAlbumMedia = false;
  });
};

export const setMediaPricingBuilder = builder => {
  builder.addCase(setMediaPricing.pending, state => {
    state.pending.setMediaPricing = true;
  });
  builder.addCase(setMediaPricing.fulfilled, state => {
    state.pending.setMediaPricing = false;
  });
  builder.addCase(setMediaPricing.rejected, state => {
    state.pending.setMediaPricing = false;
  });
};
